import { Component, OnInit, HostListener, ViewChild, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { IParallaxScrollConfig } from 'ngx-parallax-scroll';

/* import ScrollBound from "scroll-bound-animation";
var data = require("./animation.json");
new ScrollBound(data); */

import AOS from "aos";

@Component({
  selector: 'app-cymi-v2',
  templateUrl: './cymi-v2.component.html',
  styleUrls: ['./cymi-v2.component.scss']
})
export class CymiV2Component implements OnInit {

  hash: any;
  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public video5: boolean;
  public video6: boolean;
  public video7: boolean;
  public video8: boolean;
  public video9: boolean;

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };

  public fixed:boolean;
  public scroll:boolean;
  public itsMobile = false;

  constructor(private el: ElementRef, @Inject(DOCUMENT) private document: any) {
    this.hash = window.location.hash;

  }

  /* @HostListener('body:scroll', ['$event'])
  onScrollingEvent($event): void {
     let scrollOffset = $event.target.scrollTop;
     console.log(scrollOffset)

  } */

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const image = this.el.nativeElement.querySelector('.img-cymi');
    if(offset == 0){
      image.style.transform = 'translateY(0)';
      image.style.opacity = '1';
    }
  }

  loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined) {
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });

    // $.each(, function (index, theElement) {
    //
    // });
  }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    AOS.init();

    this.loadAssets();
  }
  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];


    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  openVideo(number: any) {
    this.loadAssets();
    this["video" + number] = true;
    this.pauseAllVideos();

    setTimeout(() => {
      if (number == '1') {
        const video = this.el.nativeElement.querySelector('video.main-intro');
        video.play();
      }
      else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.play();
      }else if (number == '3') {
        const video = this.el.nativeElement.querySelector('video.main-video2');
        video.play();
      }else if (number == '4') {
        const video = this.el.nativeElement.querySelector('video.main-video3');
        video.play();
      }else if (number == '5') {
        const video = this.el.nativeElement.querySelector('video.main-video4');
        video.play();
      }else if (number == '6') {
        const video = this.el.nativeElement.querySelector('video.main-video5');
        video.play();
      }else if (number == '7') {
        const video = this.el.nativeElement.querySelector('video.main-video6');
        video.play();
      }else if (number == '8') {
        const video = this.el.nativeElement.querySelector('video.main-video7');
        video.play();
      }else if (number == '9') {
        const video = this.el.nativeElement.querySelector('video.main-intro2');
        video.play();
      }
    }, 1000);

  }

  closeVideo(number: any) {
    this["video" + number] = false;
    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.main-intro');
      video.pause();
    }else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.pause();
    }else if (number == '3') {
      const video = this.el.nativeElement.querySelector('video.main-video2');
      video.pause();
    }else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.main-video3');
      video.pause();
    }else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.main-video4');
      video.pause();
    }else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.main-video5');
      video.pause();
    }else if (number == '7') {
      const video = this.el.nativeElement.querySelector('video.main-video6');
      video.pause();
    }else if (number == '8') {
      const video = this.el.nativeElement.querySelector('video.main-video7');
      video.pause();
    }else if (number == '9') {
      const video = this.el.nativeElement.querySelector('video.main-intro2');
      video.pause();
    }
  }


  pauseAllVideos(event?) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          elem.currentTime = 0;
          elem.load();
          elem.pause();
        } catch (error) {
        }
      }
    });
  }
}
